import FlexBox from '@/atomic-components/FlexBox';
import { Box, Drawer } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { IOffers } from '../../model';
import PDPDrawer from '../PdpDrawer';
import PiggyBagIcon from '../../../../assets/pdp/piggyBagIcon1.svg';
import CrossIcon from '../../../../assets/pdp/crossIcon.svg';
import { getStyle } from '@/utils/theme/fonts';
import { getColor } from '@/utils/theme/colors';
import NCemiTiles from './ncemiTile';

interface INCEMIPlanDetailInterface {
	NCEMIOffer?: IOffers;
	openEMIPlan: boolean;
	setOpenEMIPlan: () => void;
}

const NCEMIPlanDetail = (props: INCEMIPlanDetailInterface) => {
	return (
		<>
			<Drawer
				anchor='right'
				open={props.openEMIPlan}
				onClose={props.setOpenEMIPlan}
			>
				<FlexBox direction='column' sx={{ padding: '80px', width: '520px' }}>
					<FlexBox
						sx={{ justifyContent: 'space-between', paddingBottom: '32px' }}
					>
						<PiggyBagIcon />
						<Box onClick={props.setOpenEMIPlan} sx={{ cursor: 'pointer' }}>
							<CrossIcon />
						</Box>
					</FlexBox>

					{props?.NCEMIOffer?.meta && (
						<LencoTypography
							sx={{
								...getStyle('H9_Regular'),
								color: getColor('Gray 0'),
								paddingBottom: '28px',
							}}
						>
							EMI Plans
						</LencoTypography>
					)}
					<LencoTypography
						sx={{
							...getStyle('P_Regular'),
							color: getColor('Gray -2'),
							paddingBottom: '30px',
						}}
					>
						{props?.NCEMIOffer?.meta?.header}
					</LencoTypography>

					{props?.NCEMIOffer?.meta ? (
						props?.NCEMIOffer?.meta?.emiOfferDetails[0]?.map((emiData: any) => {
							return <NCemiTiles key={emiData.bankName} {...emiData} />;
						})
					) : (
						<>
							<LencoTypography sx={{ paddingBottom: '16px' }}>
								{props?.NCEMIOffer?.description}
							</LencoTypography>
							<LencoTypography>{props?.NCEMIOffer?.longDescription}</LencoTypography>
						</>
					)}

					<LencoTypography
						sx={{
							...getStyle('Small_Regular'),
							paddingTop: '24px',
							color: getColor('Gray -2'),
						}}
					>
						{props?.NCEMIOffer?.meta?.note}
					</LencoTypography>

					<FlexBox
						sx={{
							width: '200px',
							height: '48px',
							borderRadius: '100px',
							border: '1px solid #777777',
							justifyContent: 'center',
							alignItems: 'center',
							marginTop: '40px',
							cursor: 'pointer',
						}}
						onClick={props.setOpenEMIPlan}
					>
						<LencoTypography
							sx={{
								...getStyle('Small_SemiBold'),
								color: getColor('Gray -2'),
							}}
						>
							UNDERSTOOD
						</LencoTypography>
					</FlexBox>
				</FlexBox>
			</Drawer>
		</>
	);
};

export default NCEMIPlanDetail;
